import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="container py-5">
      <h2 className="mb-4 text-primary fw-bold">Privacy Policy</h2>
      <p>
        At CompraPrice, your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your personal information.
      </p>
      <h5 className="mt-4">1. Information We Collect</h5>
      <p>We may collect information like your name, email, and browsing activity to enhance your experience.</p>

      <h5 className="mt-4">2. How We Use Your Information</h5>
      <p>Your data helps us improve site functionality, provide personalized experiences, and send important updates.</p>

      <h5 className="mt-4">3. Data Security</h5>
      <p>We implement standard security measures to safeguard your data, but no method is 100% secure.</p>

      <p className="mt-4">For any questions, feel free to contact us.</p>
    </div>
  );
};

export default PrivacyPolicy;
